<template>
  <div class="container">
    <van-form @submit="onSubmit">
      <div class="block">
        <div class="sub-title">禽舍信息</div>
        <van-field
            v-model="jsLength"
            name="jsLength"
            label="禽舍长度"
            type="number"
            placeholder="请输入禽舍长度"
            :rules="[{ required: true, message: '请填写禽舍长度' }]"
        >
          <template #button>
            米
          </template>
        </van-field>
        <van-field
            v-model="jsHeight"
            v-if="!highSwitchChecked"
            type="number"
            name="jsHeight"
            label="禽舍高度"
            placeholder="请输入禽舍高度"
            :rules="[{ required: true, message: '请填写禽舍高度' }]"
        >
          <template #button>
            米
          </template>
        </van-field>

        <van-field
            v-model="jsHeight"
            v-if="highSwitchChecked"
            type="number"
            name="jsHeight"
            label="上层高度"
            placeholder="请输入禽舍上层高度"
            :rules="[{ required: true, message: '请填写禽舍上层高度' }]"
        >
          <template #button>
            米
          </template>
        </van-field>

        <van-field
            v-model="jsHeight2"
            v-if="highSwitchChecked"
            type="number"
            name="jsHeight"
            label="下层高度"
            placeholder="请输入禽舍下层高度"
            :rules="[{ required: true, message: '请填写禽舍下层高度' }]"
        >
          <template #button>
            米
          </template>
        </van-field>
      </div>

      <div class="block">
        <div class="sub-title">笼具信息</div>
        <van-field
            readonly
            clickable
            name="picker"
            :value="ljValue"
            label="笼具结构"
            placeholder="请选择几层几列"
            @click="showLjPicker = true"
            right-icon="arrow"
            :rules="[{ required: true, message: '请选择几层几列' }]"
        />
        <van-popup v-model="showLjPicker" position="bottom">
          <van-picker
              show-toolbar
              :columns="ljColumns"
              @confirm="onLjConfirm"
              @cancel="showLjPicker = false"
          />
        </van-popup>

        <van-field
            v-model="jlHeight"
            name="jlHeight"
            label="笼具高度"
            type="number"
            placeholder="请输入笼具高度"
            :rules="[{ required: true, message: '请填写笼具高度' }]"
        >
          <template #button>
            米
          </template>
        </van-field>

        <div class="tip">
          笼具高度：在高层时请填写笼具的有效高度，有效高度 = 笼具总高度 - 上层下层的间隔高度
        </div>
      </div>


      <div class="block">
        <div class="sub-title">球泡信息</div>
        <van-field
            readonly
            clickable
            name="picker"
            :value="lightValue"
            label="球泡规格"
            placeholder="请选择球泡规格"
            @click="showLightPicker = true"
            right-icon="arrow"
            :rules="[{ required: true, message: '请选择球泡规格' }]"
        />
        <van-popup v-model="showLightPicker" position="bottom">
          <van-picker
              show-toolbar
              :columns="lightSpecs"
              @confirm="onLightConfirm"
              @cancel="showLightPicker = false"
          />
        </van-popup>

        <van-field
            v-model="lightPrice"
            name="lightPrice"
            label="球泡单价"
            type="number"
            placeholder="请输入球泡单价"
            :rules="[{ required: true, message: '请输入球泡单价' }]"
        >
          <template #button>
            元
          </template>
        </van-field>

        <van-field
            v-model="azSpace"
            name="azSpace"
            label="安装间距"
            type="number"
            placeholder="请输入安装间距"
            :rules="[{ required: true, message: '请输入安装间距' }]"
        >
          <template #button>
            米
          </template>
        </van-field>


        <van-field
            readonly
            clickable
            name="azTypeValue"
            :value="azTypeValue"
            label="安装方式"
            placeholder="请选择安装方式"
            @click="showAzPicker = true"
            right-icon="arrow"
            :rules="[{ required: true, message: '请选择安装方式' }]"
        />
        <van-popup v-model="showAzPicker" position="bottom">
          <van-picker
              show-toolbar
              :columns="azTypes"
              @confirm="onAzConfirm"
              @cancel="showAzPicker = false"
          />
        </van-popup>
      </div>

      <div class="block">
        <div class="sub-title">控制柜电源</div>
        <van-field
            readonly
            clickable
            name="dyControlMode"
            :value="dyControlMode"
            label="电源控制"
            placeholder="请选择电源控制模式"
            @click="showDyPicker = true"
            right-icon="arrow"
            :rules="[{ required: true, message: '请选择电源控制模式' }]"
        />
        <van-popup v-model="showDyPicker" position="bottom">
          <van-picker
              show-toolbar
              :columns="dyModes"
              @confirm="onDyConfirm"
              @cancel="showDyPicker = false"
          />
        </van-popup>

        <van-field v-if="smFlag" name="dySpec" label="电源规格">
          <template #input>
            <van-radio-group v-model="dySpec" direction="horizontal">
              <van-radio name="1">800W优先</van-radio>
              <van-radio name="2">500W优先</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <van-field name="dgMode" label="多柜类型">
          <template #input>
            <van-radio-group v-model="dgMode" direction="horizontal">
              <van-radio name="1">主副柜</van-radio>
              <van-radio name="0">两主柜</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <div class="tip">
          电源控制：【经济模式】在功率满足时优先以一块电源控制两列灯光，【单列单控模式】一个电源控制一列灯光
        </div>
      </div>


      <div class="block">
        <div class="sub-title">价格设置</div>
        <van-field
            readonly
            clickable
            name="slMode"
            :value="slMode"
            label="是否含税"
            placeholder="请选择税率"
            @click="showSlPicker = true"
            right-icon="arrow"
            :rules="[{ required: true, message: '请选择税率' }]"
        />
        <van-popup v-model="showSlPicker" position="bottom">
          <van-picker
              show-toolbar
              :columns="slModes"
              @confirm="onSlConfirm"
              @cancel="showSlPicker = false"
          />
        </van-popup>


        <van-field
            v-model="upRatio"
            name="upRatio"
            label="价格上浮"
            type="number"
            placeholder="请输入价格上浮比例"
            :rules="[{ required: true, message: '请输入价格上浮比例' }]"
        >
          <template #button>
            %
          </template>
        </van-field>
      </div>

      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">查询</van-button>
      </div>
    </van-form>

  </div>
</template>

<script>

export default {
  name: "index",
  data() {
    return {
      // 是否是森迈用户访问
      smFlag: false,
      jsLength: '',
      jsHeight: '',
      jsHeight2: '',
      // 笼具选择
      ljValue: '六层六列',
      showLjPicker: false,
      ljColumns: [
        // 第一列
        {
          values: [
            {text: '三层', value: 3},
            {text: '四层', value: 4},
            {text: '五层', value: 5},
            {text: '六层', value: 6},
            {text: '八层', value: 8},
          ],
          defaultIndex: 3,
        },
        // 第二列
        {
          values: [
            {text: '二列', value: 2},
            {text: '三列', value: 3},
            {text: '四列', value: 4},
            {text: '五列', value: 5},
            {text: '六列', value: 6},
            {text: '七列', value: 7},
            {text: '八列', value: 8},
          ],
          defaultIndex: 4,
        },
      ],
      jlLayer: 6,
      jlColumn: 6,
      jlHeight: '',
      // 球泡选择
      showLightPicker: false,
      lightValue: '7W',
      lightSpecs: [
        {
          values: [
            {text: '7W', value: 7},
            {text: '10W', value: 10},
            {text: '12W', value: 12},
            {text: '15W', value: 15},
          ],
          defaultIndex: 0,
        },
      ],
      lightSpec: 7,
      lightPrice: '12',
      azSpace: 2.0,

      // 球泡安装方式选择
      showAzPicker: false,
      azTypes: [
        {
          values: [
            {text: '相同高度', value: 1},
            {text: '高-低', value: 2},
            {text: '高-中-低', value: 3},
          ],
          defaultIndex: 1,
        },
      ],
      azTypeValue: '高-低',
      azLevel: 2,

      // 电源控制模式选择
      dyControlMode: '经济模式',
      showDyPicker: false,
      dyMode: 0,
      dyModes: [
        {
          values: [
            {text: '经济模式', value: 0},
            {text: '单列单控模式', value: 1},
          ],
          defaultIndex: 0,
        },
      ],
      // 是否高层禽舍
      highSwitchChecked: true,
      // 是否含税选择
      showSlPicker: false,
      slMode: "不含税",
      slModeValue: 1,
      slModes: [
        {
          values: [
            {text: '不含税', value: 1},
            {text: '小规模', value: 2},
            {text: '一般纳税人', value: 3},
          ],
          defaultIndex: 0,
        },
      ],
      // 价格上浮
      upRatio: '0',
      // 多柜类型
      dgMode: '1',
      // 电源规格
      dySpec: "1"
    };
  },
  created() {
    const query = this.$route.query;
    console.log('created:', query)
    this.smFlag = query.f === "sm"
  },
  methods: {
    onSubmit(values) {
      const params = {
        smFlag: this.smFlag,
        jsLength: parseFloat(this.jsLength),
        jsHeight: parseFloat(this.jsHeight),
        jsHeight2: parseFloat(this.jsHeight2),
        highMode: this.highSwitchChecked,
        jlLayer: this.jlLayer,
        jlColumn: this.jlColumn,
        jlHeight: parseFloat(this.jlHeight),
        lightSpec: parseInt(this.lightSpec),
        lightPrice: parseFloat(this.lightPrice),
        azSpace: parseFloat(this.azSpace),
        azLevel: this.azLevel,
        dyMode: this.dyMode,
        dgMode: parseInt(this.dgMode),
        slMode: this.slModeValue,
        upRatio: parseInt(this.upRatio),
        dySpec: parseInt(this.dySpec)
      }
      console.log(params)
      let height = 0;
      if (params.highMode) {
        height = params.jsHeight + params.jsHeight2
      } else {
        height = params.jsHeight
      }
      if (height < params.jlHeight) {
        this.$toast("笼具高度不能>禽舍高度")
        return;
      }

      // 高层时，如果列超过5，不能进行单列单控
      if (params.highMode && params.jlColumn > 5 && params.dyMode === 1) {
        this.$toast("高层禽舍电源控制请选择【经济模式】")
        return;
      }

      this.$router.push({
        name: 'bjd-result',
        params
      });
    },
    // 笼具层列结构选择
    onLjConfirm(value) {
      const layer = value[0].text
      const column = value[1].text
      this.ljValue = `${layer}${column}`
      // console.log(`层：${layer},value=${value[0].value}, 列：${column}`);
      this.jlLayer = value[0].value
      this.jlColumn = value[1].value
      // 大于5层的，都是高层
      this.highSwitchChecked = this.jlLayer > 5
      this.showLjPicker = false
    },
    // 球泡规格选择
    onLightConfirm(value) {
      this.lightValue = value[0].text
      this.lightSpec = value[0].value
      this.showLightPicker = false
    },
    // 球泡安装方式选择
    onAzConfirm(value) {
      this.azTypeValue = value[0].text
      this.azLevel = value[0].value
      this.showAzPicker = false
    },
    // 电源控制模式选择
    onDyConfirm(value) {
      this.dyControlMode = value[0].text
      this.dyMode = value[0].value
      this.showDyPicker = false
    },
    // 税率模式选择
    onSlConfirm(value) {
      this.slMode = value[0].text
      this.slModeValue = value[0].value
      this.showSlPicker = false
    },

  },
}
</script>

<style lang="less" scoped>
.container {
  padding: 12px;

  .title {
    font-size: 16px;
    font-weight: bold;
    width: 100%;
    text-align: center;
  }


  .block {
    margin-bottom: 16px;

    .sub-title {
      font-size: 15px;
      font-weight: bold;
      color: #2c2c2c;
      margin-bottom: 10px;
    }
  }

  .tip {
    font-size: 12px;
    margin-top: 8px;
    color: #d35400;
    margin-left: 4px;
  }
}

</style>
